import { render, staticRenderFns } from "./RoleUsers.vue?vue&type=template&id=bbb6fa54&"
import script from "./RoleUsers.vue?vue&type=script&lang=js&"
export * from "./RoleUsers.vue?vue&type=script&lang=js&"
import style0 from "./RoleUsers.vue?vue&type=style&index=0&id=bbb6fa54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports